/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Group_SourcesInputs */

const en_why_listening_compare_group_sources = /** @type {(inputs: Why_Listening_Compare_Group_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you can listen to`)
};

const es_why_listening_compare_group_sources = /** @type {(inputs: Why_Listening_Compare_Group_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué puedes escuchar`)
};

/**
* | output |
* | --- |
* | "What you can listen to" |
*
* @param {Why_Listening_Compare_Group_SourcesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_group_sources = /** @type {((inputs?: Why_Listening_Compare_Group_SourcesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Group_SourcesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_group_sources(inputs)
	return en_why_listening_compare_group_sources(inputs)
});